import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { RefundItemResponse } from "../types"

export const useGetSingleRefundItem = (refund_return_id: number) => {
  const api = useApi()
  const [data, setData] = useState<RefundItemResponse | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchingDataApi = () => api.get(`/received/detail_refund_return?refund_return_id=${refund_return_id}`)

  const fetchingData = () => {
    setLoading(true);

    fetchingDataApi()
    .then((res: SuccessFetch<RefundItemResponse>) => setData(res.data))
    .catch(() => setData(null))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchingData();

  useEffect(() => {
    fetchingData();

    return () => {
      setData(null);
      setLoading(true);
    }
    // eslint-disable-next-line
  }, [refund_return_id])


  return { data, isLoading, refetch }
}